/**
 * ReindexModalPreview — dev-only public route (`/preview/reindex-modal`)
 * that renders the ReindexPromptModal in each of its three states side by
 * side so operators can review copy + layout without needing to log in
 * and trigger a real upload.
 *
 * Not linked from anywhere. Zero impact on shipped auth-gated flow.
 * Delete or gate behind `NODE_ENV !== 'production'` after copy sign-off.
 */
import React, { useState } from 'react';
import ReindexPromptModal from '../components/app/ReindexPromptModal';

const STATES = [
  {
    label: 'A · Initial (post-upload) — modal opens',
    running:  false,
    progress: null,
  },
  {
    label: 'B · Running — M3 phase, 25 %',
    running:  true,
    progress: { phase: 'm3', progress: 25 },
  },
  {
    label: 'C · Running — M4 phase, 75 %',
    running:  true,
    progress: { phase: 'm4', progress: 75 },
  },
];

const REINDEX_PROMPT = {
  partition:    'SearchInc_TheRevolution',
  since:        new Date().toISOString(),
  upload_count: 3,
};

export default function ReindexModalPreview() {
  const [idx, setIdx] = useState(0);
  const st = STATES[idx];
  return (
    <div className="min-h-screen bg-slate-950 text-cyan-100">
      <div className="fixed inset-x-0 top-0 z-[100] border-b border-cyan-400/30 bg-slate-900/95 px-6 py-4 backdrop-blur">
        <div className="mx-auto max-w-5xl">
          <h1 className="text-lg font-semibold">
            Reindex Modal · Copy Review Preview
          </h1>
          <p className="mt-1 text-xs text-cyan-300/70">
            Dev-only sandbox at <code>/preview/reindex-modal</code>. Not
            linked from the app.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {STATES.map((s, i) => (
              <button
                key={s.label}
                type="button"
                onClick={() => setIdx(i)}
                className={
                  'rounded border px-3 py-1.5 text-xs transition-colors ' +
                  (i === idx
                    ? 'border-cyan-300 bg-cyan-500/20 text-cyan-100'
                    : 'border-slate-500/40 bg-slate-800/60 text-slate-300 hover:border-cyan-400/60')
                }
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <ReindexPromptModal
        reindexPrompt={REINDEX_PROMPT}
        reindexRunning={st.running}
        reindexProgress={st.progress}
        onConfirm={() => {}}
        onSkip={() => {}}
      />
    </div>
  );
}
